import _ from 'lodash'
import store from '@store'
import router from '@studio/router'
import defineSDK from '@utils/dependencies'
import { mapActions, mapMutations } from 'vuex'
import * as T from '@store/types'
import { GET_WORKSPACE_LIST } from '@common/store/workspace/types'
import { WORKSPACE } from '@common/store/module-types'
import { web, ThemeWrapper, themeUtils } from '@mypaas/app-render-engine/core/sdk'
// import { isFormComponent } from '@common/utils/validate'
import { filterDevComponents } from '../../common/utils/dev-component'

const { design } = web

export default {
    methods: {
        ...mapActions({
            fetchAppDetail: T.GET_APP_DETAIL,
            getComponents: T.GET_COMPONENTS,
            getLocalComponents: T.GET_LOCAL_COMPONENT,
        }),
        ...mapActions(WORKSPACE, {
            GET_WORKSPACE_LIST,
        }),
        ...mapMutations({
            setClassifyComponents: T.SET_CLASSIFY_COMPONENTS,

            // 新增
            // setPresetedComponents: T.SET_PRESETED_COMPONENT,
            // setCustomizeComponents: T.SET_CUSTOMIZE_COMPONENT,
            // setBuiltinComponents: T.SET_BUILTIN_COMPONENT,
            // setSpecialComponents: T.SET_SPECIAL_COMPONENT,
            // //setFormComponents: T.SET_FORM_COMPONENT,
        }),
        async fetchData() {
            const { workspaceId, appId } = this.$route.params
            this.getBranches(appId, workspaceId)
            let devComponents = []

            const res = await Promise.all([
                this.fetchAppDetail({ workspaceId, appId }),
                this.getComponents(),
            ])
            
            if (this.isDevComponent) {
                devComponents = await this.getLocalComponents()
            }
            const {
                inner, system, custom, special,
            } = res[1]

            this.initSeajs(res, [...system, ...custom])

            await defineSDK(
                res[0],
                store,
                router,
                design.install,
                {
                    ...design.plugin,
                    themes: {
                        ThemeWrapper,
                        themeUtils,
                    },
                }
            )

            const items = []

            _.forEach(special, item => {
                if (item.type !== 'hook') {
                    items.push(item)
                }
            })
            // this.setPresetedComponents(filterDevComponents(system, devComponents))
            // this.setCustomizeComponents(filterDevComponents(custom, devComponents))
            // this.setBuiltinComponents(filterDevComponents(inner, devComponents))
            // this.setSpecialComponents(filterDevComponents(items, devComponents))
            // // this.setFormComponents(filterDevComponents(system.filter(isFormComponent), devComponents))

            this.setClassifyComponents({
                system: filterDevComponents(system, devComponents),
                custom: filterDevComponents(custom, devComponents),
                inner: filterDevComponents(inner, devComponents),
                special: filterDevComponents(items, devComponents),
                dev: devComponents,
            })

            this.loadEmulator().then(() => {
                this.visible = true
            })
        },
        getBranches(appId, workspaceId) {
            this.GET_WORKSPACE_LIST({
                appId,
                workspaceId,
                pageSize: 10,
                page: 1,
                workspaceName: '',
            })
        },
    },
}
